import { useEffect, useMemo, useState } from 'react';
import { builder } from '@builder.io/sdk';
import builderConfig from '../../builder-config';
import { builderModels } from './builderPage';
import { selectCurrentPencilEntry } from './usePromoCountdown';

const apiKey = builderConfig?.builderAPIKey;

builder.init(apiKey);

export function useBuilderPromotionsBannerData() {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // Query shape (limit, sort, cachebust/noTargeting) must stay in sync
                // with the build-time static query in usePromoCountdown.js — otherwise
                // the pencil banner and the countdown can pick different entries.
                // Gatsby's useStaticQuery can't accept runtime constants, so there's
                // no shared source; keep both files aligned by hand.
                //
                // Picks the entry that currently owns the pencil banner: the first in
                // list order (createdDate desc) that has started. A scheduled entry
                // whose startDate hasn't passed can't preempt the current one, and an
                // expired entry stays visible until the next scheduled entry takes
                // over — see selectCurrentPencilEntry. noTargeting returns scheduled
                // and expired entries too, so the schedule is applied here instead of
                // being short-circuited by Builder's server clock.
                const entries = await builder.getAll(builderModels.promotionsBanners, {
                    limit: 10,
                    sort: { createdDate: -1 },
                    options: { published: 'published', noTargeting: true },
                });

                setContent(selectCurrentPencilEntry(entries, Date.now()));
            } catch (error) {
                console.log('unable to fetch builder data', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const promotionalBannersTextData = {
        grandSpecialsBanner: content?.data?.grandSpecialsBanner,
        specialsBanner: content?.data?.specialsBanner,
    };

    return useMemo(() => {
        return {
            promotionalBannersTextData,
            builderContentData: content,
            isLoading: loading,
        };
    }, [content, loading, promotionalBannersTextData]);
}
